import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
//Plugin
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { ClientesService } from "../../../services/clientes.service";

@Component({
  selector: 'simulador-cliente',
  templateUrl: './simulador-cliente.component.html',
  styleUrls: ['./simulador-cliente.component.scss']
})
export class SimuladorClienteComponent implements OnInit {

  @Input() public cliente: any = {};
  @Input() public errors: any = {};
  //Cliente form
  public showClaveElector: boolean = false;
  //Typeahead utilities
  public tempClient: any = {};
  private originalClient: any = null;
  public searching = false;
  public searchFailed = false;
  public isARegisteredCliente = false;
  // Allow both or initialize as null/number
  public estadoPorDefecto: string | number = "";
  public estadoSelected: any = {};
  public OptEstados = [{ id: 1, nombre: "Aguascalientes" }, { id: 2, nombre: "Baja California" }, { id: 3, nombre: "Baja California Sur" }, { id: 4, nombre: "Campeche" },
  { id: 5, nombre: "Chiapas" }, { id: 6, nombre: "Chihuahua" }, { id: 7, nombre: "Ciudad de México" }, { id: 8, nombre: "Coahuila" }, { id: 9, nombre: "Colima" }, { id: 10, nombre: "Durango" }, { id: 11, nombre: "Estado de México" },
  { id: 12, nombre: "Guanajuato" }, { id: 13, nombre: "Guerrero" }, { id: 14, nombre: "Hidalgo" }, { id: 15, nombre: "Jalisco" }, { id: 16, nombre: "Michoacán" }, { id: 17, nombre: "Morelos" }, { id: 18, nombre: "Nayarit" }, { id: 19, nombre: "Nuevo León" },
  { id: 20, nombre: "Oaxaca" }, { id: 21, nombre: "Puebla" }, { id: 22, nombre: "Querétaro" }, { id: 23, nombre: "Quintana Roo" }, { id: 24, nombre: "San Luis Potosí" }, { id: 25, nombre: "Sinaloa" }, { id: 26, nombre: "Sonora" }, { id: 27, nombre: "Tabasco" },
  { id: 28, nombre: "Tamaulipas" }, { id: 29, nombre: "Tlaxcala" }, { id: 30, nombre: "Veracruz" }, { id: 31, nombre: "Yucatán" }, { id: 32, nombre: "Zacatecas" }];

  constructor(
    private clientesService: ClientesService
  ) {
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.cliente && this.cliente) {
      this.tempClient = this.cliente;
      //Se necesita clonar el objeto, para guardar una referencia su valor iniciar (Update case)
      this.originalClient = Object.assign({}, this.cliente);
      // 🔥 NUEVO: Inicializar el select si el cliente ya trae un estado
      if (this.cliente.estado) {
        this.selectEstado(this.cliente.estado);
      }
    }
  }

  /**
   * Typeahead functions
   */
  public formatter = (x: { email: string }) => x.email;

  public searchCliente = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.clientesService.search({ email: term }).pipe(
          tap(() => this.searchFailed = false),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }))
      ),
      tap(() => this.searching = false)
    );

  public selectCliente(event: any) {
    console.log("Cliente seleccionado:", event.item);

    this.cliente.id = event.item.id;
    this.cliente.email = event.item.email;
    this.cliente.nombre = event.item.nombre;
    this.cliente.telefono = event.item.telefono;
    this.cliente.direccion = event.item.direccion;
    this.cliente.clave_elector = event.item.clave_elector;
    this.cliente.rfc = event.item.rfc;

    // Procesamos el estado para que el Select2 lo reconozca
    if (event.item.estado) {
      this.selectEstado(event.item.estado);
    }

    this.isARegisteredCliente = true;
  }

  estadoChanged(estado) {
    if (estado && estado.id) {
      this.estadoSelected = estado;
      // GUARDAR SOLO EL ID (Número)
      this.cliente.estado = estado.id;
    } else {
      // Fallback si se limpia el select
      if (this.OptEstados && this.OptEstados.length > 0) {
        this.estadoSelected = this.OptEstados[0];
        this.cliente.estado = this.estadoSelected.id;
      }
    }
  }
  private selectEstado(estado) {
    // Buscamos el objeto que coincida ya sea con el ID o con el Nombre
    const encontrado = this.OptEstados.find(tipo =>
      tipo.id == estado || tipo.nombre === estado
    );

    if (encontrado) {
      this.estadoSelected = encontrado;
      // IMPORTANTE: Para el componente select2-single, actualiza también el default
      this.estadoPorDefecto = encontrado.id;
      // Guardamos solo el ID en el objeto cliente para evitar el "0" en la DB
      this.cliente.estado = encontrado.id;
    } else {
      // Fallback: si no encuentra nada, usa el primer estado
      this.estadoSelected = this.OptEstados[0];
      this.estadoPorDefecto = this.estadoSelected.id;
      this.cliente.estado = this.estadoSelected.id;
    }
  }

  public onEmailChange() {
    //Este evento se dispara cuando se modifica de forma manual el valor del email
    //Por lo tanto ya no esta seleccionado un cliente existente
    this.isARegisteredCliente = false;
  }

  public afterEmailChange() {
    //Si se selecciona un cliente existente haciendo Tab, se dispara este evento
    //En este caso hay que omir este proceso ya que la función selectCliente hizo la asignación
    if (typeof this.tempClient === 'object') {
      return false;
    }

    //Este proceso se ejecuta cuadno se ingreso un email de forma manual
    this.cliente.email = this.tempClient;
    if (this.originalClient) {
      //Si se modifico el email del cliente original entonces, se vuelven a asignar sus propiedades originales, para no sobreescribirlas
      this.cliente.id = this.originalClient.id;
      this.cliente.direccion = this.originalClient.direccion;
      this.cliente.telefono = this.originalClient.telefono;
      this.cliente.clave_elector = this.originalClient.clave_elector;
      this.cliente.rfc = this.originalClient.rfc;
    } else {
      //Si es un registro nuevo ponemos su id en null ya que el API lo requiere así para crear un nuevo cliente
      this.cliente.id = null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/simulador-cliente/simulador-cliente.component.ts